import { getCustomHeaderTextColor } from '@/utils/getCustomHeaderTextColor';
import { HeaderInfoIcon } from '@/assets/svgExports/HeaderInfoIcon';
import ShopComponent from '../../Headers/ShopComponent';
import CommonNavbarText from '../../Headers/CommonNavbarText/CommonNavbarText';
import { getRoute, PATH } from '@/utils/routes';
import router from 'next/router';
import { useSSRSelector } from '@/redux/ssrStore';
import { useMemo, useState } from 'react';
import { AccordionCloseIcon, AccordionOpenIcon } from '../MegaMenuDrawerDesktop/svgIcons';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import { isPLPRequiredSystem } from 'src/utils/isPLPRequiredSystem';
import { useNavlinkStyling } from 'src/hooks/useNavlinkStyling';
import CommonLinkWrapper from '../../Widgets2.0/CommonLinkWrapper';
import { validateLink } from 'src/utils/validateLink';
import {
  getRedirectLinkForSlug,
  useGetDropdownListforShopComponent,
} from '../../Widgets2.0/Header/utils';
import { checkIfUrlHasExternalLink } from 'src/utils/checkIfUrlHasExternalLink';

export const baseNavItemClass =
  ' tw-w-[100%] tw-border-b-[1px] tw-border-solid tw-border-[#111C36]/[0.12] tw-py-[16px] tw-text-[14px] tw-font-normal tw-leading-[18px] ';

export const useGetNavList = (navigationList) => {
  const subNavObj = {
    page_type: 'subNavList',
    subNavs: [],
    is_editable: false,
    page_id: '616d2bd6152384798123d775',
    page_name: 'More',
    slug_url: 'subNavList',
  };

  const list = useMemo(() => {
    if (navigationList?.length > 0) {
      const tempNavList = [...navigationList];

      if (navigationList?.length > 5) {
        const extractedNavList = tempNavList.splice(5, tempNavList.length);
        subNavObj.subNavs = extractedNavList;
        const newNavList = [...tempNavList, subNavObj];
        return newNavList;
      } else {
        return navigationList;
      }
    }
  }, [navigationList]);

  return list;
};

export const OldNavigationItem = ({
  page,
  dropdownNav = false,
  isLastListBox,
  showMegaMenuMobileOnDesktopDrawer = false,
  ...props
}) => {
  const headerBgColor = props?.config?.color_scheme?.bg_color || '#ffffff';
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const [openMore, setOpenMore] = useState(false);

  const menuItemClick = (nav) => {
    if (nav?.page_type === 'blank_page' && nav?.is_external_url) {
      window.open(nav.slug_url, '_blank');
      props.closeParentContainer?.();
      return;
    } else if (nav.slug_url === 'subNavList') {
      setOpenMore(!openMore);
    } else {
      if (nav.is_editable) {
        router.push(
          getRoute(PATH.additionalPage(nav.slug_url), storeData?.store_info?.domain)
        );
      } else {
        router.push(getRoute(nav.slug_url, storeData?.store_info?.domain));
      }
      props.closeParentContainer?.();
    }
  };

  const navSubList = (nav) => {
    return (
      <div className={'tw-mt-[22.5px] tw-font-dmSans'}>
        <div className={''}>
          {nav.map((n, index, arr) => (
            <p
              key={n.page_id}
              className={twMerge(
                'tw-m-0 tw-text-[13px] tw-font-semibold',
                index !== arr?.length - 1 && 'tw-pb-[15.5px]'
              )}
              onClick={() => menuItemClick(n)}
            >
              {n.page_name}
            </p>
          ))}
        </div>
      </div>
    );
  };

  switch (page.slug_url) {
    case '':
      return (
        <li
          key={page.page_id}
          className={` relative ` + baseNavItemClass}
          onClick={() => menuItemClick(page)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center" style={{ flex: '1 1 auto' }}>
              <CommonNavbarText
                classes={props.customItemClasses}
                bgColor={headerBgColor}
                page={page}
              />
            </div>
          </div>
        </li>
      );
    case 'shop':
      return (
        <ShopComponent
          page={page}
          showIcon={false}
          baseClass={baseNavItemClass}
          fromMobileMenuDrawer
          customItemClasses={props.customItemClasses}
          showMegaMenuMobileOnDesktopDrawer={showMegaMenuMobileOnDesktopDrawer}
          closeParentContainer={props.closeParentContainer}
        />
      );
    case 'subNavList':
      return (
        <li
          key={page?.page_id}
          className={` relative ` + baseNavItemClass}
          onClick={() => menuItemClick(page)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center" style={{ flex: '1 1 auto' }}>
              <CommonNavbarText
                classes={props.customItemClasses}
                page={{ page_name: 'More' }}
                bgColor={headerBgColor}
              />
            </div>
            {page?.subNavs?.length > 0 &&
              (!openMore ? (
                <AccordionCloseIcon
                // secondaryColor={invertAngleRightIconColor(headerBgColor)}
                />
              ) : (
                <AccordionOpenIcon
                // secondaryColor={invertAngleRightIconColor(headerBgColor)}
                />
              ))}
          </div>
          {openMore && navSubList(page.subNavs)}
        </li>
      );
    case 'about-us':
      return (
        <li
          key={page.page_id}
          className={
            ` relative ` + (props.fromMobileMenuDrawer ? baseNavItemClass : 'menu-item')
          }
          onClick={() => menuItemClick(page)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center" style={{ flex: '1 1 auto' }}>
              {!props.fromMobileMenuDrawer && (
                <div className="mr3 visible-mobile">
                  <HeaderInfoIcon
                    color={
                      storeData?.theme?.colors?.primary_color !== '#ffffff'
                        ? '#000000'
                        : '#ffffff'
                    }
                  />
                </div>
              )}
              <CommonNavbarText
                classes={props.customItemClasses}
                bgColor={headerBgColor}
                page={page}
              />
            </div>
          </div>
        </li>
      );
    default:
      return (
        <li
          key={page.page_id}
          className={`${baseNavItemClass} ${getCustomHeaderTextColor(headerBgColor)} ${isLastListBox ? '!tw-border-none' : ''} ${props.customItemClasses}`}
          onClick={() => menuItemClick(page)}
        >
          {page.page_name}
        </li>
      );
  }
};

export const NewNavigationItem = ({
  data,
  isLastListBox,
  background = '#ffffff',
  closeParentContainer,
  ...props
}) => {
  const headerBgColor = props?.config?.color_scheme?.bg_color || '#ffffff';
  const { store, categories, productTags, navigationList } = useSSRSelector((state) => ({
    store: state.storeReducer.store,
    categories: state.catalogReducer.categories || [],
    productTags: state.catalogReducer.productTags || [],
    navigationList: state.additionalPagesReducer.navigationList || [],
  }));
  const [isDropdownOpened, setIsOpenDropdown] = useState(false);
  const isTypeDropdown = data.type === 'dropdown';
  const allCategories = [...categories, ...productTags];
  const { getNavElementStyle } = useNavlinkStyling();
  const navElementStyle = getNavElementStyle();
  const { getDropdownList } = useGetDropdownListforShopComponent();

  if (!data.showOnHeader) {
    return null;
  }

  const navItemClick = (link: string, openInNewTab = false) => {
    if (openInNewTab) {
      window.open(link, '_blank');
    } else {
      router.push(getRouteLink(link || '/'));
    }
  };

  function getCategoryLink(currentCategory) {
    if (currentCategory?.id === undefined) {
      currentCategory = categories?.find((val) => val?.name === currentCategory?.name);
    }
    return getRoute(
      `${
        isPLPRequiredSystem(store?.theme?.theme_class) ? PATH.SHOP : PATH.PRODUCT
      }?cid=${currentCategory?.id || ''}`,
      store?.store_info?.domain
    );
  }

  function getRouteLink(link) {
    return getRoute(link, store?.store_info?.domain);
  }

  function handleCategoryClick(currentOptionData) {
    const {
      isShopComponent,
      redirectionLink,
      redirectNewPage: openInNewTab,
    } = currentOptionData || {};

    if (isShopComponent) {
      const currentCategory = allCategories?.find(
        (val) => val?.id === currentOptionData?.id
      );
      if (
        typeof currentCategory?.id === 'number' ||
        typeof currentCategory?.id === 'string'
      ) {
        router.push(getCategoryLink(currentCategory), undefined, { shallow: true });
      }
    } else {
      const redLink = getRedirectLinkForSlug(
        navigationList,
        validateLink(redirectionLink),
        currentOptionData?.id
      );
      const link = openInNewTab
        ? checkIfUrlHasExternalLink(redirectionLink)
          ? redirectionLink
          : getRoute(redirectionLink, store?.store_info?.domain)
        : redLink;
      navItemClick(link, openInNewTab);
    }
    closeParentContainer?.();
  }

  const navSubList = (nav, isShopComponent) => {
    const updatedNav = getDropdownList(isShopComponent, nav);
    return (
      <div
        className={'tw-mt-[22.5px] tw-max-h-[200px] tw-overflow-y-auto tw-font-dmSans'}
      >
        {updatedNav.map((navItem, idx, totalNavItems) => {
          const navItemLatest = allCategories?.find((val) => val?.id === navItem?.id);
          return (
            <CommonLinkWrapper
              key={navItem?.page_id}
              onClick={() => closeParentContainer?.()}
              handleCustomClick={
                navItem?.redirectNewPage
                  ? () =>
                      handleCategoryClick({
                        ...navItem,
                        isShopComponent,
                      })
                  : undefined
              }
              disableLink={navItem?.redirectNewPage}
              link={
                isShopComponent
                  ? getCategoryLink(navItem)
                  : getRouteLink(
                      getRedirectLinkForSlug(
                        navigationList,
                        validateLink(navItem?.redirectionLink),
                        navItem?.id
                      )
                    )
              }
            >
              <p
                className={classNames(
                  'tw-m-0 tw-font-semibold ',
                  totalNavItems?.length - 1 !== idx && 'tw-mb-[17.5px] ',
                  props.customItemClasses
                )}
                style={navElementStyle}
              >
                {(navItemLatest || navItem)?.name}
              </p>
            </CommonLinkWrapper>
          );
        })}
      </div>
    );
  };

  if (props?.showMegaMenu) {
    return (
      <ShopComponent
        page={props.megaMenuData}
        showIcon={false}
        baseClass={baseNavItemClass}
        fromMobileMenuDrawer
        customItemClasses={props.customItemClasses}
        showMegaMenuMobileOnDesktopDrawer={props?.showMegaMenuMobileOnDesktopDrawer}
        closeParentContainer={closeParentContainer}
        style={navElementStyle}
        background={background}
      />
    );
  }

  return (
    <li
      className={` relative ${baseNavItemClass}  ${isLastListBox ? '!tw-border-none' : ''} `}
      style={{
        borderColor: navElementStyle.borderColor,
      }}
    >
      {data.redirectionLink || (data?.isDefaultNavList && !data?.option) ? (
        <CommonLinkWrapper
          onClick={() => closeParentContainer?.()}
          handleCustomClick={
            data?.redirectNewPage ? () => handleCategoryClick(data) : undefined
          }
          disableLink={data?.redirectNewPage}
          link={getRouteLink(
            getRedirectLinkForSlug(
              navigationList,
              validateLink(data?.redirectionLink),
              data?.id
            )
          )}
        >
          <div
            className={classNames(
              'tw-select-none tw-font-dmSans ',
              props.customItemClasses
            )}
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            <CommonNavbarText
              page={{ page_name: data.name }}
              bgColor={headerBgColor}
              style={navElementStyle}
            />
          </div>
        </CommonLinkWrapper>
      ) : (
        <div>
          <div
            className="flex items-center justify-between tw-cursor-pointer "
            onClick={() => setIsOpenDropdown(!isDropdownOpened)}
          >
            <div className="flex items-center" style={{ flex: '1 1 auto' }}>
              <CommonNavbarText
                classes={props.customItemClasses}
                page={{ page_name: data.name }}
                bgColor={headerBgColor}
                style={navElementStyle}
              />
            </div>
            {isTypeDropdown &&
              (isDropdownOpened ? (
                <AccordionCloseIcon secondaryColor={navElementStyle.color} />
              ) : (
                <AccordionOpenIcon secondaryColor={navElementStyle.color} />
              ))}
          </div>
          {isDropdownOpened && navSubList(data.option, data?.isShopComponent)}
        </div>
      )}
    </li>
  );
};
